(() => {
  const root = document.querySelector('.meresso-product--oregano');
  if (!root) return;

  const radios = [...root.querySelectorAll('[data-meresso-bundles] input[type="radio"]')];
  let pendingQuantity = null;
  let observedPopup = null;
  const selectedPack = () => radios.find((radio) => radio.checked);
  const offerQuantity = (offer) => {
    const title = offer.querySelector('.mb-1')?.textContent.trim() || '';
    const match = title.match(/^\s*(?:Compra\s+)?(\d+)\s*(?:unidad(?:es)?|unidade(?:s)?|uds?\.?|embalage(?:m|ns))\b/i);
    return match ? Number(match[1]) : null;
  };
  const stylePurchaseButtons = () => {
    const buttons = [...root.querySelectorAll('.es-popup-button-product')];
    const sticky = document.querySelector('#es-sticky.es-sticky-product');
    if (sticky) buttons.push(sticky);
    const pack = selectedPack();
    const quantity = Number(pack?.value || 1);
    const settings = root.querySelector('[data-meresso-bundles]')?.dataset || {};
    const text = pack
      ? `${settings.orderLabel} ${quantity} ${quantity === 1 ? settings.unitOne : settings.unitMany} · ${pack.dataset.total}`
      : settings.codLabel;
    buttons.forEach((button) => {
      button.style.setProperty('background', '#315d42', 'important');
      button.style.setProperty('border-radius', '9px', 'important');
      const label = button.querySelector('.es-button-title, .es-button-content span');
      if (label && label.textContent !== text) label.textContent = text;
    });
    const formButton = document.querySelector('#easysell #es-form-button');
    if (formButton) formButton.style.setProperty('background', '#315d42', 'important');
  };

  const syncNativePack = () => {
    const popup = document.querySelector('#easysell');
    if (!popup || !popup.getClientRects().length || getComputedStyle(popup).display === 'none') {
      root.dataset.meressoPackSync = 'waiting-for-form';
      return;
    }
    const country = popup.querySelector('select[name="country"]');
    if (location.pathname.startsWith('/pt-pt/') && country && !country.value && [...country.options].some((option) => option.value === 'PT')) {
      country.value = 'PT';
      country.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (pendingQuantity === null) return;
    const packSettings = root.querySelector('[data-meresso-bundles]')?.dataset || {};
    [...popup.querySelectorAll('.es-qo-container')].forEach((item) => {
      const quantity = offerQuantity(item);
      const title = item.querySelector('.mb-1');
      const label = `${quantity} ${quantity === 1 ? packSettings.unitOne : packSettings.unitMany}`;
      if (quantity && title && title.textContent !== label) title.textContent = label;
      const badge = item.querySelector('.es-offer-badge');
      const radio = radios.find((option) => Number(option.value) === quantity);
      if (badge && radio && quantity > 1 && badge.textContent.trim() && badge.textContent !== radio.dataset.offerTag) badge.textContent = radio.dataset.offerTag;
    });
    const offer = [...popup.querySelectorAll('.es-qo-container')]
      .find((item) => offerQuantity(item) === pendingQuantity);
    if (!offer) {
      root.dataset.meressoPackSync = 'waiting-for-offers';
      return;
    }
    root.dataset.meressoPackSync = `selected-${pendingQuantity}`;
    pendingQuantity = null;
    offer.querySelector('.mb-1').click();
  };

  const popupObserver = new MutationObserver(syncNativePack);
  const observePopup = () => {
    const popup = document.querySelector('#easysell');
    const target = popup?.closest('#easysell-modal') || popup;
    if (!target || target === observedPopup) return;
    popupObserver.disconnect();
    observedPopup = target;
    popupObserver.observe(target, {
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  };

  root.addEventListener('change', (event) => {
    if (radios.includes(event.target)) {
      pendingQuantity = Number(event.target.value);
      root.dataset.meressoSelectedPack = event.target.value;
      stylePurchaseButtons();
    }
  });
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('.es-popup-button-product, #es-sticky.es-sticky-product');
    if (trigger && (root.contains(trigger) || trigger.id === 'es-sticky')) {
      pendingQuantity = Number(selectedPack()?.value || 1);
      root.dataset.meressoPackSync = 'opening-form';
      observePopup();
      requestAnimationFrame(syncNativePack);
    }
    const offer = event.target.closest('#easysell .es-qo-container');
    if (offer) {
      const radio = radios.find((item) => Number(item.value) === offerQuantity(offer));
      if (radio) {
        radio.checked = true;
        stylePurchaseButtons();
      }
    }
  }, true);

  const observer = new MutationObserver(() => {
    stylePurchaseButtons();
    observePopup();
    syncNativePack();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  stylePurchaseButtons();
  observePopup();
})();
